import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Logo').create(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '211px',
    height: '124px',

    img: {
      width: '100%',
      height: '100%',
    },
  },
}))
